/** @format */

import {
	AppProductReviewState,
	InvalidResponse,
	ProductReviewAnalyticsService,
	Review,
	UtilityReviewService,
	openReviewImageModal,
	selectProductReviewProductIdentifier,
	selectProductReviewsMultimedia
} from '@product-reviews/data-access';
import { Component, DestroyRef, OnInit } from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconPhotoImagesFilled
} from '@dsg-tech/homefield-angular-icons';
import { Observable, filter } from 'rxjs';

import { CommonModule } from '@angular/common';
import { HmfActionTextComponent } from '@dsg-tech/homefield-angular';
import { Store } from '@ngrx/store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'product-reviews-multimedia-count',
    imports: [
        CommonModule,
        HmfActionTextComponent,
        HomefieldIconLibraryModule
    ],
    templateUrl: './review-multimedia-count.component.html',
    styleUrl: './review-multimedia-count.component.scss'
})
export class ReviewMultimediaCountComponent implements OnInit {
	selectReviewsMultimedia$: Observable<Review[] | InvalidResponse> = this.store.select(
		selectProductReviewsMultimedia
	);
	selectProductId$ = this.store.select(selectProductReviewProductIdentifier);
	mediaCount: number;

	constructor(
		private readonly store: Store<AppProductReviewState>,
		private readonly destroyRef: DestroyRef,
		private utilityReviewService: UtilityReviewService,
		private readonly analyticsService: ProductReviewAnalyticsService,
		homefieldIconsLibraryService: HomefieldIconsLibraryService
	) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconPhotoImagesFilled
		]);
	}

	ngOnInit() {
		this.selectReviewsMultimedia$
			.pipe(
				takeUntilDestroyed(this.destroyRef),
				filter(reviewsMultimedia => !(reviewsMultimedia instanceof InvalidResponse))
			)
			.subscribe((reviewsMultimedia:Review[]) => {
				this.mediaCount = this.utilityReviewService.transformReviewMedia([...reviewsMultimedia]).length;
			});
	}


	handleClick() {
		this.trackReviewSummaryImagesClicked();
		this.openMultimediaReview();
	}

	openMultimediaReview() {
		this.store.dispatch(openReviewImageModal());
	}

	trackReviewSummaryImagesClicked() {
		const payload = {
			event: 'ReviewSummaryClicked',
			value: 'Images'
		};

		this.analyticsService.fireReviewAnalytics<{ [key: string]: string }>({
			name: 'multiUseAnalyticsEvent',
			payload
		});
	}
}
